import BaseAgencyScopeEntityDto from '@/models/Shared/BaseAgencyScopeEntityDto';
import ActivityContactRole from './ActivityContactRole';

export default class ActivityContactDto extends BaseAgencyScopeEntityDto {
    activityId = '';
    contactRole: ActivityContactRole = ActivityContactRole.ToRecipient;
    contactId: string | null = null;
    workerId: string | null = null;
    agencyUserId: string | null = null;
    contactName = '';
    contactEmail = '';
    contactPhone = '';
    participationStatus: number | null = null;
}
